import { useAuthStore } from "../store/auth.store";
import { useEffect, useState } from "react";
import { useTranslation } from "../hooks/useTranslation";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { useCompanyStore } from "../store/company.store";
import { useCompanyList } from "../hook/partner/company.partner.hook";
import { Accordion } from "react-bootstrap";
import { NavLink } from "react-router";

function Klienti() {
  const { t } = useTranslation();
  const companiesMutation = useCompanyList();
  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);

  const token = useAuthStore((state) => state.token);
  const companies = useCompanyStore((state) => state.companyList);

  useEffect(() => {
    if (token) {
      companiesMutation.mutate({ token });
    }
  }, [token]);

  useEffect(() => {
    setPagename(t("navigation.contacts"));
    setBreadcrumbs([]);
  }, [t]);

  if (companiesMutation.isLoading) {
    return <div className="alert alert-primary">{t("common.loading")}...</div>;
  }

  return (
    <>
      {companies && companies.length > 0 ? (
        <>
          <Accordion defaultActiveKey={0}>
            {companies.map((letter, lindex) => (
              <Accordion.Item key={lindex} eventKey={lindex}>
                <Accordion.Header>
                  {letter.letter}{" "}
                  <span className="ms-4 badge badge-warning">
                    {letter.company_count}
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    {letter.companies.map((company) => (
                      <div className="col-md-4 mb-4" key={company.company_id}>
                        <div className="card h-100">
                          <div className="card-body">
                            <h3>
                              <NavLink to={"/klient/" + company.company_id}>
                                {company.name}
                              </NavLink>
                            </h3>
                            <p>{company.city}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </>
      ) : (
        <div className="alert alert-danger">
          {t("company.noClients")}...
        </div>
      )}
    </>
  );
}

export default Klienti;
